<template>
  <el-dialog
    title="批量发送消息"
    :visible.sync="dialogVisible"
    :width="width"
    :before-close="handleClose"
  >
    <div class="bulk-send-container">
      <div class="upload-area" v-if="!fileUploaded">
        <div style="display: flex; flex-direction: column">
          <el-upload
            ref="excelUpload"
            class="upload-excel"
            drag
            action=""
            :auto-upload="false"
            :on-change="handleFileChange"
            :limit="1"
            accept=".xlsx,.xls"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将Excel文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传xlsx/xls文件，文件需包含username和hellostring列
            </div>
          </el-upload>
          <el-button
            @click="downlaodExcel"
            style="margin-top: 10px"
            type="primary"
            >下载模版</el-button
          >
        </div>
      </div>

      <div v-if="fileUploaded" class="data-display">
        <div class="action-buttons">
          <el-button type="primary" icon="el-icon-upload" @click="resetUpload"
            >重新上传</el-button
          >
          <el-button
            type="success"
            icon="el-icon-s-promotion"
            @click="startSendMessages"
            :loading="isSending"
            :disabled="isSending"
            >发送</el-button
          >
          <el-button
            type="warning"
            icon="el-icon-video-pause"
            @click="interruptSending"
            :disabled="!isSending"
            >中断</el-button
          >
          <el-button
            type="info"
            icon="el-icon-video-play"
            @click="continueSending"
            :disabled="!isInterrupted"
            >继续</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            @click="exportData"
            :loading="isSending"
            :disabled="isSending"
            >导出数据</el-button
          >
          <el-button
            type="danger"
            icon="el-icon-download"
            @click="exportFailedData"
            :disabled="
              isSending || !tableData.some((item) => item.status === '发送失败')
            "
          >
            导出失败数据
          </el-button>
        </div>
        <div class="action-buttons" style="display: flex; align-items: center">
          <span>打招呼模版:</span>
          <el-select
            size="mini"
            v-model="modelText"
            clearable
            placeholder="选择打招呼模版组"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.groupName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button
            v-if="modelText"
            type="primary"
            @click="onUpData"
            size="mini"
            >保存</el-button
          >
        </div>

        <div class="progress-bar" v-if="isSending || isInterrupted">
          <el-progress
            :percentage="progressPercentage"
            :status="
              isInterrupted
                ? 'exception'
                : progressPercentage === 100
                ? 'success'
                : undefined
            "
          ></el-progress>
          <div class="progress-text">{{ progressText }}</div>
        </div>

        <el-table
          :data="tableData"
          style="width: 100%"
          max-height="400"
          border
          v-loading="tableLoading"
        >
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="username"
            label="用户名"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="accountName"
            label="分配账号"
            width="120"
          ></el-table-column>
          <el-table-column prop="hellostring" label="问候语"></el-table-column>
          <el-table-column prop="status" label="状态" width="120">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)">{{
                scope.row.status
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                @click="sendSingleMessage(scope.row)"
                :disabled="isSending || scope.row.status === '发送成功'"
                >发送</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="logs-area">
          <div class="logs-header">
            <h3>发送日志</h3>
            <span>
              <el-button type="text" @click="exprotLogs">导出日志</el-button>
              <el-button type="text" @click="clearLogs">清空日志</el-button>
            </span>
          </div>
          <div class="logs-content" ref="logsContent">
            <div v-for="(log, index) in logs" :key="index" class="log-item">
              <span class="log-time">{{ log.time }}</span>
              <span :class="['log-message', log.type]">{{ log.message }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import * as XLSX from "xlsx";
import http from "@/api/httpRequest.js";

export default {
  name: "BulkSendMessages",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uid: "",
      time: 120000,
      options: [],
      modelText: null,
      dialogVisible: false,
      fileUploaded: false,
      tableData: [],
      tableLoading: false,
      excelFile: null,
      isSending: false,
      isInterrupted: false,
      isAddingFriends: false,
      currentIndex: 0,
      totalItems: 0,
      logs: [],
      sendTask: null,
      progressPercentage: 0,
      progressText: "",
      width: "40%",
      consecutiveFailedCount: 0,
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    // 下载模版
    downlaodExcel() {
      const link = document.createElement("a");
      link.href = "/template/template2.xlsx";
      link.download = "批量用户名打招呼模版.xlsx";
      link.click();
    },
    // 导出数据
    exportData() {
      const worksheet = XLSX.utils.json_to_sheet(this.tableData, {
        header: ["username", "hellostring", "status"],
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "结果日志");
      XLSX.writeFile(workbook, "结果日志.xlsx");
    },
    // 导出失败数据
    exportFailedData() {
      const failedData = this.tableData.filter(
        (item) => item.status === "发送失败"
      );
      if (failedData.length === 0) {
        this.$message.info("没有失败的数据可导出");
        return;
      }
      const worksheet = XLSX.utils.json_to_sheet(failedData, {
        header: ["username", "hellostring", "status"],
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "失败数据");
      XLSX.writeFile(workbook, "失败数据.xlsx");
    },
    // 移除文件
    removeFile() {
      const uploadRef = this.$refs.excelUpload;
      if (uploadRef && typeof uploadRef.clearFiles === "function") {
        uploadRef.clearFiles();
      }
    },
    // 关闭模态框
    handleClose() {
      if (this.isSending) {
        this.$confirm("任务正在进行中，确定要关闭吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.interruptSending();
            this.resetData();
            this.dialogVisible = false;
            this.width = "40%";
            this.modelText = null;
            this.removeFile();
          })
          .catch(() => {});
      } else {
        this.resetData();
        this.$emit("close");
        this.dialogVisible = false;
        this.width = "40%";
        this.modelText = null;
        this.removeFile();
      }
    },
    // 重置数据
    resetData() {
      this.fileUploaded = false;
      this.tableData = [];
      this.excelFile = null;
      this.isSending = false;
      this.isInterrupted = false;
      this.isAddingFriends = false;
      this.currentIndex = 0;
      this.totalItems = 0;
      this.logs = [];
      this.progressPercentage = 0;
      this.progressText = "";
      this.consecutiveFailedCount = 0;
    },
    // 获取打招呼模版
    getGreetList() {
      this.$http.get("/client/greet").then((res) => {
        this.options = res;
      });
    },
    // 随机获取一个模版
    onUpData() {
      const object = this.options.find((item) => {
        return item.id == this.modelText;
      });
      this.tableData.forEach((item) => {
        const randomIndex = Math.floor(
          Math.random() * object.greetInfoList.length
        );
        item.hellostring = object.greetInfoList[randomIndex].content;
      });
    },
    // 上传文件
    handleFileChange(file) {
      this.tableLoading = true;
      this.excelFile = file.raw;

      if (!this.excelFile) {
        this.$message.error("文件上传失败，请重试");
        this.tableLoading = false;
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          if (jsonData.length === 0) {
            this.$message.error("Excel文件为空或格式不正确");
            this.tableLoading = false;
            return;
          }

          // 检查必要的列
          const firstRow = jsonData[0];
          if (
            !Object.prototype.hasOwnProperty.call(firstRow, "username") ||
            !Object.prototype.hasOwnProperty.call(firstRow, "hellostring")
          ) {
            this.$message.error("Excel文件必须包含username和hellostring列");
            this.tableLoading = false;
            return;
          }

          // 均分分配账号
          const accounts = this.$store.state.cicadeStore.accounts.filter(
            (account) =>
              account.status === 1 &&
              account.greetLimitStatus === 1 &&
              account.limitStatus === 1 &&
              account.countLimitStatus === 1
          );
          if (!accounts || accounts.length === 0) {
            this.$message.error("没有可用账号，请先登录账号");
            this.tableLoading = false;
            return;
          }
          
          this.tableData = jsonData.map((row, idx) => {
            const account = accounts[idx % accounts.length];
            return {
              ...row,
              status: "待处理",
              accountTryIndex: 0,
              accountId: account.accountId,
              accountName: account.account || account.accountName,
              originalAccountId: account.accountId, // 💡 保存最初分配账号
              originalAccountName: account.account || account.accountName,
            };
          });

          this.totalItems = this.tableData.length;
          this.fileUploaded = true;
          this.addLog("info", `成功导入${this.totalItems}条数据`);
          this.uid = Date.now();
          this.width = "70%";
          this.getGreetList();
        } catch (error) {
          this.$message.error("解析Excel文件失败，请检查文件格式");
        } finally {
          this.tableLoading = false;
        }
      };
      reader.readAsArrayBuffer(this.excelFile);
    },
    // 重新上传
    resetUpload() {
      if (this.isSending) {
        this.$message.warning("发送任务进行中，请先中断任务");
        return;
      }
      this.width = "40%";
      this.fileUploaded = false;
      this.tableData = [];
      this.excelFile = null;
      this.currentIndex = 0;
      this.totalItems = 0;
      this.progressPercentage = 0;
      this.progressText = "";
      this.modelText = null;
      this.removeFile();
    },
    // 开始发送
    startSendMessages() {
      if (this.tableData.length === 0) {
        this.$message.warning("没有可发送的数据");
        return;
      }

      this.isSending = true;
      this.isInterrupted = false;
      this.addLog("info", "开始批量发送消息");
      this.processNextItem();
    },
    // 中断发送
    interruptSending() {
      if (!this.isSending) return;

      this.isSending = false;
      this.isInterrupted = true;
      clearTimeout(this.sendTask);
      const sentCount = this.tableData.filter(
        (item) => item.status !== "待处理"
      ).length;
      this.progressPercentage =
        this.totalItems > 0
          ? Math.floor((sentCount / this.totalItems) * 100)
          : 0;
      this.addLog(
        "warning",
        `发送任务中断，已处理${sentCount}/${this.totalItems}条`
      );
      this.progressText = `已发送 (${sentCount}/${this.totalItems})`;
    },
    // 继续发送
    continueSending() {
      if (!this.isInterrupted) return;

      this.isSending = true;
      this.isInterrupted = false;
      this.addLog("info", `继续发送任务，从第${this.currentIndex + 1}条开始`);
      this.processNextItem();
    },
    // 更新进度
    updateProgress() {
      const sentCount = this.tableData.filter(
        (item) => item.status !== "待处理"
      ).length;
      this.progressPercentage =
        this.totalItems > 0
          ? Math.floor((sentCount / this.totalItems) * 100)
          : 0;
      this.progressText = `已发送 (${sentCount}/${this.totalItems})`;
    },
    // 发送消息
    async sendMessage(item) {
      return http({
        url: "/client/greetStranger",
        method: "post",
        params: {
          accountId: item.accountId, // 用分配的账号
          username: item.username,
          greeting: item.hellostring,
          uid: this.uid,
        },
      });
    },
    // 发送单个消息
    async sendSingleMessage(row) {
      if (this.isSending) return;
      try {
        this.$set(row, "status", "发送中...");
        await this.sendMessage(row);
        this.$set(row, "status", "发送成功");
        this.addLog(
          "success",
          `账号:${row.accountName}成功发送消息给 ${row.username}`
        );
      } catch (error) {
        this.$set(row, "status", "发送失败");
        this.addLog(
          "error",
          `账号:${row.accountName}发送消息给 ${row.username}失败，失败原因: ${
            error.message || "未知错误"
          }`
        );
      } finally {
        this.updateProgress();
      }
    },
    // 处理下一个数据
    async processNextItem() {
      // 检查发送状态和索引
      if (!this.isSending || this.currentIndex >= this.tableData.length) {
        if (this.isSending) {
          this.isSending = false;
          this.addLog("success", "所有消息发送完成");
          this.updateProgress();
          this.progressText = `发送完成 (${this.totalItems}/${this.totalItems})`;
        }
        return;
      }

      // 当前数据item
      const item = this.tableData[this.currentIndex];
      // 筛选可用账号
      const accounts = this.$store.state.cicadeStore.accounts.filter(
        (account) =>
          account.status === 1 &&
          account.greetLimitStatus === 1 &&
          account.limitStatus === 1 &&
          account.countLimitStatus === 1
      );
      if (!accounts || accounts.length === 0) {
        this.$message.error("没有可用账号，发送任务已中断！");
        this.isSending = false;
        this.isInterrupted = true;
        this.addLog("error", "发送过程中账号全部失效，任务已中断！");
        this.updateProgress();
        return;
      }

      // 只处理待处理的数据
      if (item.status !== "发送成功" && item.status !== "发送失败") {
        try {
          // ✅ 第一次尝试：用原始分配账号
          if (item.accountTryIndex === 0) {
            item.accountId = item.originalAccountId;
            item.accountName = item.originalAccountName;
          } else {
            // ✅ 第2次及之后：从 accounts 中选择新账号（排除之前的）
            const availableAccounts = accounts.filter(
              (acc) => acc.accountId !== item.originalAccountId
            );
            const tryIndex = item.accountTryIndex - 1; // 因为第0次是原始账号
            if (availableAccounts.length > 0) {
              const fallback =
                availableAccounts[tryIndex % availableAccounts.length];
              item.accountId = fallback.accountId;
              item.accountName = fallback.account || fallback.accountName;
            }
          }

          await this.sendMessage(item);
          this.$set(item, "status", "发送成功");
          this.consecutiveFailedCount = 0;
          this.addLog(
            "success",
            `账号:${item.accountName}成功发送消息给 ${item.username}`
          );
          // 下一个数据
          this.currentIndex++;
          this.updateProgress();
          this.sendTask = setTimeout(() => {
            this.processNextItem();
          }, this.time);
        } catch (error) {
          // 不是真人用户
          if (error.code == 1111) {
            this.$set(item, "status", "发送失败");
            this.addLog(
              "error",
              `账号:${item.accountName}发送消息给 ${
                item.username
              }失败，失败原因: ${error.message || "未知错误"}`
            );
            this.consecutiveFailedCount = 0;
            // 跳过继续处理下一个数据
            this.currentIndex++;
            this.updateProgress();
            this.sendTask = setTimeout(() => {
              this.processNextItem();
            }, this.time);
            return;
          }
          // 尝试下一个账号
          item.accountTryIndex = (item.accountTryIndex || 0) + 1;
          const length = accounts.length >= 10 ? 10 : accounts.length;
          // 如果尝试次数小于10次
          if (item.accountTryIndex < length) {
            this.addLog(
              "warning",
              `账号:${item.accountName}发送消息给 ${
                item.username
              } 失败，失败原因:${error.message || "未知错误"} 尝试下一个账号:${
                accounts[item.accountTryIndex].account
              }（${item.accountTryIndex + 1}/${accounts.length}）`
            );
            // 不递增 currentIndex，继续用下一个账号尝试
            this.sendTask = setTimeout(() => {
              this.processNextItem();
            }, this.time);
            return;
          } else {
            // 如果尝试次数超过10次，则跳过该数据
            this.$set(item, "status", "发送失败");
            this.consecutiveFailedCount++;
            if (this.consecutiveFailedCount >= 3) {
              this.addLog(
                "error",
                "连续多条数据所有账号都发送失败，任务已中断！"
              );
              this.interruptSending();
              this.$confirm(
                "已经连续有数据多个账号都发送失败，任务已中断，可以导出结果查看发送失败和待发送数据。",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              );
              return;
            }
            this.addLog(
              "error",
              `多个账号发送消息给 ${item.username}均失败，失败原因: ${
                error.message || "未知错误"
              }`
            );
            // 下一个数据
            this.currentIndex++;
            this.updateProgress();
            this.sendTask = setTimeout(() => {
              this.processNextItem();
            }, this.time);
          }
        }
      }
    },
    // 添加日志
    addLog(type, message) {
      const time = new Date().toLocaleTimeString();
      this.logs.push({ time, type, message });
      this.$nextTick(() => {
        if (this.$refs.logsContent) {
          this.$refs.logsContent.scrollTop =
            this.$refs.logsContent.scrollHeight;
        }
      });
    },
    // 清空日志
    clearLogs() {
      this.logs = [];
    },
    // 导出日志
    exprotLogs() {
      const worksheet = XLSX.utils.json_to_sheet(this.logs, {
        header: ["time", "type", "message"],
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "打印日志");
      XLSX.writeFile(workbook, "打印日志.xlsx");
    },
    // 获取状态类型
    getStatusType(status) {
      switch (status) {
        case "发送成功":
        case "已加好友":
          return "success";
        case "发送失败":
        case "添加失败":
          return "danger";
        case "发送中...":
        case "添加中...":
          return "warning";
        default:
          return "info";
      }
    },
  },
};
</script>

<style scoped>
.bulk-send-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-area {
  display: flex;
  justify-content: center;
  padding: 20px;
}

.action-buttons {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
}

.progress-bar {
  margin-bottom: 15px;
}

.progress-text {
  margin-top: 5px;
  text-align: center;
  color: #606266;
}

.logs-area {
  margin-top: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.logs-header {
  padding: 8px 15px;
  border-bottom: 1px solid #e4e7ed;
  background-color: #f5f7fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logs-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}

.logs-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 150px;
  overflow-y: auto;
  padding: 10px 15px;
  background-color: #fafafa;
}

.log-item {
  padding: 4px 0;
}

.log-time {
  color: #909399;
  margin-right: 8px;
}

.log-message {
  word-break: break-word;
}

.log-message.success {
  color: #67c23a;
}

.log-message.error {
  color: #f56c6c;
}

.log-message.warning {
  color: #e6a23c;
}

.log-message.info {
  color: #409eff;
}
</style>
